export type InboxOwnerScope = "mine" | null;

export function seesWholeInbox(canViewAll: boolean, agentInboxRestricted: boolean): boolean {
  return canViewAll && !agentInboxRestricted;
}

export function ownInboxIsMine(hasTeam: boolean, wholeInbox: boolean): boolean {
  return hasTeam && !wholeInbox;
}

export function inboxOwnerScope({
  teamAgentId,
  scope,
  hasTeam,
  wholeInbox,
}: {
  teamAgentId: string | null;
  scope: string | null;
  hasTeam: boolean;
  wholeInbox: boolean;
}): InboxOwnerScope {
  if (teamAgentId) return null;
  if (scope === "mine") return "mine";
  return ownInboxIsMine(hasTeam, wholeInbox) ? "mine" : null;
}
